import { Component, OnInit } from '@angular/core';
import { Member } from 'src/app/models/member.model';
import { MemberService } from 'src/app/services/member.service';
import { COUNTRY_TYPES, POSITION_TYPES, GP_TYPES } from 'src/app/enums/enums';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.css'],
  providers: [MemberService, UserService]
})
export class MemberComponent implements OnInit {
  public members: Member[];
  public identity: string;
  public token: string;
  public status: string;
  public member: Member;
  public form: FormData = new FormData();
  public one: number = 1;
  public two: number = 2;
  public three: number = 3;
  public four: number = 4;
  public five: number = 5;
  public six: number = 6;
  public seven: number = 7;
  public eight: number = 8;
  public nine: number = 9;
  public then: number = 10;
  public page: number = 1;
  public pageSize: number = 10;
  public loading: boolean = false;
  public isSubmitting: boolean = false;
  public isDeleting: boolean = false;
  public isUpdating: boolean = false;

  public countryTypes: string[] = [
    COUNTRY_TYPES.ELSALVADOR,
    COUNTRY_TYPES.GUATEMALA,
    COUNTRY_TYPES.HONDURAS,
    COUNTRY_TYPES.NICARAGUA,
    COUNTRY_TYPES.PANAMA,
    COUNTRY_TYPES.RPDOMINICANA
  ];

  public positionTypes: string[] = [
    POSITION_TYPES.PRESIDENTE,
    POSITION_TYPES.VICEPRESIDENTE,
    /* POSITION_TYPES.SECRETARIA, */
    POSITION_TYPES.TESORERO,
    POSITION_TYPES.VOCAL,
    POSITION_TYPES.INTEGRANTE,
  ]
  public gpTypes: string[] = [
    GP_TYPES.GPI,
    GP_TYPES.GPICD,
    GP_TYPES.UDI
  ]


  public paislbl: any = [
    { name: "EL SALVADOR", type: "EL SALVADOR" },
    { name: "GUATEMALA", type: "GUATEMALA" },
    { name: "HONDURAS", type: " HONDURAS" },
    { name: "azul", type: "Elecciones JD" },
    { name: "gris", type: "Otros" },
  ]
  constructor(
    private _membersService: MemberService,
    private _userService: UserService,
    private _router: Router,
    protected _sanitizer: DomSanitizer,
  ) {
    this.clearMember();
  }

  ngOnInit(): void {
    $('html,body').scrollTop(0);
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    if (!this.identity || !this.token)
      this._router.navigate(['/iniciar-sesion']);
    else
      this.listarDiputados();
  }

  listarDiputados(): void {
    this.loading = true;
    this._membersService.listMember().subscribe(

      res => {
        if (res.member?.length <= 0) {
          this.status = 'error';
        } else {
          if (res.member?.length === 0) {
            alert('No hay noticias para mostrar');
          } else {
            this.members = res.member;
            console.log(this.members);
          }
          this.status = 'ok';
        }
        this.loading = false;
      },
      err => this.onError(err)
    );
  }
  sortArray(arrayObj: any[]): any[] {
    return arrayObj.sort((a, b) =>
      (b.creationDate + b.creationTime).localeCompare(a.creationDate + a.creationTime)
    );
  }

  addMember(): void {

    if (this.member.position === 'PRESIDENTE') {
      this.member.priority = this.one;
    }
    if (this.member.position === 'VICE-PRESIDENTE') {
      this.member.priority = this.two;
    }
    if (this.member.position === 'SECRETARIA') {
      this.member.priority = this.three;
    }
    if (this.member.position === 'TESORERO') {
      this.member.priority = this.four;
    }
    if (this.member.position === 'VOCAL') {
      this.member.priority = this.five;
    }
    if (this.member.position === 'INTEGRANTE') {
      this.member.priority = this.nine;
    }

    this._membersService.addMember(this.member).subscribe(
      response => {
        if (response.member) {
          this.status = 'ok';
          this.clearMember();
          confirm("Registro agregado exitosamente");
        }
      },
      error => {
        var errorMessage = error;
        if (errorMessage != null) {
          this.status = 'error'
        }
      }
    );
    this.listarDiputados();
  }
  onError(error: any): void {
    let errorMessage = error;
    alert("Error al ejecutar la acción");
    if (errorMessage != null) {
      this.status = 'error';
    }
    this.loading = false;
    this.isSubmitting = false;
    this.isDeleting = false;
    this.isUpdating = false;
  }
  clearMember() {
    this.member = new Member('', '', '', '', '', '', 0);
  }
  setMember(members: Member): void {
    this.member = members;
  }
  deleteEvent() {
    if (confirm("¿esta seguro de que quiere eliminar?")) {
      this._membersService.deleteMember(this.member.id).subscribe(
        response => {
          if (response.member) {
            this.listarDiputados();
            this.status = "ok"

          }
        }, error => {
          var errorMessage = <any>error
          if (errorMessage != null) {
            this.status = 'error'
          }
        }
      )
    }
    this.listarDiputados();
  }
  actulizarDiputado() {
    if (this.member.position === 'PRESIDENTE') {
      this.member.priority = this.one;
    }
    if (this.member.position === 'VICE-PRESIDENTE') {
      this.member.priority = this.two;
    }
    if (this.member.position === 'SECRETARIA') {
      this.member.priority = this.three;
    }
    if (this.member.position === 'TESORERO') {
      this.member.priority = this.four;
    }
    if (this.member.position === 'VOCAL') {
      this.member.priority = this.five;
    }
    if (this.member.position === 'INTEGRANTE') {
      this.member.priority = this.nine;
    }
    this._membersService.updateMember(this.member).subscribe(
      response => {
        if (!response.member) {
          this.status = 'error';
        } else {
          this.listarDiputados();
          //this.members = this.sortArray(this.members);
          this.clearMember();
          confirm("Registro agregado exitosamente");
        }
        this.isUpdating = false;
      },
      err => this.onError(err)
    )
  }
}
